<template>
  <div>
    <div class="grid-x grid-margin-x mb-3">
      <div class="cell medium-6 large-5 max-w-sm">
        <fieldset>
          <div class="form-group">
            <label for="first-name" class="form-label" v-html="bp('firstName')"> </label>
            <input
              id="first-name"
              type="text"
              readonly="true"
              name="first-name"
              qaid="first-name"
              required="required"
              :value="pickedFirstName"
              class="form-control"
            />
          </div>
          <div class="form-group is-required">
            <label for="last-name" class="form-label" v-html="bp('lastName')"> </label>
            <input
              id="last-name"
              type="text"
              readonly="true"
              name="last-name"
              required="required"
              qaid="last-name"
              :value="pickedLastName"
              class="form-control"
            />
          </div>
          <div class="form-group is-required ">
            <label for="email-address" class="form-label" v-html="bp('emailAddress')"> </label>
            <input
              id="email-address"
              type="email"
              readonly="true"
              name="email-address"
              required="required"
              qaid="email-address"
              :value="pickedEmailAddress"
              class="form-control"
            />
          </div>
        </fieldset>

        <form ref="editForm" method="post" qaid="edit-user-details-form" @submit="submit">
          <fieldset class="form-fieldset">
            <input id="CSRFToken" type="hidden" :value="token" name="CSRFToken" />
            <legend class="form-fieldset__legend strong" v-html="bp('userRole')"></legend>
            <label
              v-for="(item, index) in itemsParsed.roles"
              :key="index"
              :qaid="`option-${index}`"
              :for="`option-${index}`"
              class="radio"
            >
              <input
                :id="`option-${index}`"
                v-model="pickedRole"
                type="radio"
                name="user-role"
                :value="item.id"
                :qaid="`option-${index}`"
                required="required"
              />
              <span class="control-indicator"></span>
              {{ item.name }}
            </label>
          </fieldset>

          <fieldset class="form-fieldset">
            <input id="CSRFToken" type="hidden" :value="token" name="CSRFToken" />
            <legend class="form-fieldset__legend strong" v-html="bp('userRole')"></legend>
            <label qaid="updateAll" class="checkbox">
              <input v-model="updateAll" type="checkbox" name="allStores" :value="true" />
              <span class="control-indicator"></span>
              <div>
                {{ bp('updateAllTitle') }}
                <div class="form-help">{{ bp('updateAllDescription') }}</div>
              </div>
            </label>
          </fieldset>

          <fieldset class="form-fieldset">
            <legend class="form-fieldset__legend strong" v-html="bp('userStatus')"></legend>
            <div class="sprocket__toggle-switch mr-2">
              <input id="active-user" v-model="pickedStatus" class="switch-input" type="checkbox" name="active-user" />
              <label class="switch-paddle" for="active-user"></label>
              <span class="text-black font-medium ml-1" v-html="userStatusToggleIndicator"></span>
            </div>
          </fieldset>

          <div class="buttons">
            <trek-button id="saveEditUserButton" primary qaid="save-edit-button" type="submit">
              <span v-html="bp('saveButton')"></span>
            </trek-button>
            <trek-link id="cancelEditUserButton" button secondary :href="cancelButtonRef" qaid="cancel-edit-button">
              <span v-html="bp('cancelButton')"></span>
            </trek-link>
          </div>
        </form>
      </div>

      <el-dialog
        :visible.sync="dialogVisible"
        :title="bp('updateAllTitle')"
        :center="false"
        :modal="true"
        top="40vh"
        :modal-append-to-body="false"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :z-index="16000011"
        :close-dialog-tooltip="bp('closeDialogToolTip')"
      >
        <p>{{ bp('updateAllConfirmation') }}</p>
        <template slot="footer">
          <div class="buttons buttons--center">
            <trek-button primary @click.stop="confirmUpdateAll">
              <span v-html="bp('updateAllConfirmButton')"></span>
            </trek-button>
            <trek-button secondary @click.stop="closeDialog">
              <span v-html="bp('updateAllCancelButton')"></span>
            </trek-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';

export default {
  components: {TrekButton, TrekLink},
  props: {
    items: {
      type: String,
      default: '',
    },
    token: {
      type: String,
      default: '',
    },
    cancelButtonRef: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      itemsParsed: JSON.parse(this.items),
      pickedRole: '',
      pickedFirstName: '',
      pickedLastName: '',
      pickedEmailAddress: '',
      pickedStatus: false,
      updateAll: false,
      dialogVisible: false,
      canSubmit: true,
    };
  },
  computed: {
    userStatusToggleIndicator() {
      return this.bp(this.pickedStatus ? 'textActive' : 'textInactive');
    },
  },
  watch: {
    updateAll(value) {
      this.canSubmit = !value;
    },
  },
  created() {
    this.pickedRole = this.itemsParsed.role.id;
    this.pickedStatus = this.itemsParsed.userStatus;
    this.pickedFirstName = this.itemsParsed.firstName;
    this.pickedLastName = this.itemsParsed.lastName;
    this.pickedEmailAddress = this.itemsParsed.emailAddress;
  },
  methods: {
    submit(e) {
      if (this.updateAll && !this.canSubmit) {
        this.dialogVisible = true;
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    confirmUpdateAll() {
      this.dialogVisible = false;
      this.canSubmit = true;
      this.$refs.editForm.submit();
    },
    closeDialog() {
      this.updateAll = false;
      this.dialogVisible = false;
    },
  },
};
</script>
